import { takeEvery, put, call } from "redux-saga/effects";
import { types } from "../reducers/amp";
import { types as ownershipKycTypes } from "../reducers/ownership-kyc";
import { types as mineProfileTypes } from "../reducers/mine-profile";
import { StakeholderService } from "../../services";
import { formatErrors } from "../../helpers/ErrorFormater";
import { MessageTypes } from "../../helpers/Messages";
import i18next from "i18next";
import AmpService from "../../services/AmpService";
import { message } from "antd";

function* get({ value }) {
  try {
    const {
      data,
    } = yield call(() => AmpService.get(value || {}));

    yield put({
      type: types.AMP_SUCCESS,
      value: {
        amps: data.data,
        totalItems: data?.meta?.total || data?.meta?.totalItems || 0,
        ampOptions: {
          countries: data?.meta?.countries || [],
          minerals: data?.meta?.minerals || [],
          status: data?.meta?.status || [],
        },
      }
    });
  } catch (e) {
    const formattedErrors = formatErrors(e)
    yield put({
      type: types.AMP_FAILED,
      value: formattedErrors,
    });
  }
}

function* getData({ value }) {
  try {
    const isNew = (value.view || []).includes('new');

    const { data } = yield call(() => AmpService.getData({
      namespace: value.namespace,
      scope: value.scope || (isNew ? 'global' : undefined),
    }));

    const form = Object.keys(data).reduce((all, key) => {
      if (!isNew && key === 'newAmp') {
        return all;
      }

      const _this = Object.keys(data[key])
        .sort((a, b) => data[key][a].position - data[key][b].position)
        .reduce((all, k) => {
          if (k === 'scope') {
            return all;
          }

          all[k] = data[key][k];
          return all;
        }, {});

      all[key] = _this;
      return all;
    }, {});

    if (data) {
      const { data: resData } = value.datastakeId
        ? yield call(() => AmpService.getOne(value.datastakeId, undefined, value.sourceId))
        : { data: {} };

      const _data = {
        form,
        config: {},
        data: {
          ...resData,
          ampStatus: resData.status,
        },
        linkingForms: {},
      };

      yield put({
        type: types.AMP_DATA_SUCCESS,
        value: {
          [`${value.module}-${value.view}`]: _data,
        },
      });
    }
  } catch (e) {
    const formattedErrors = formatErrors(e)
    yield put({
      type: types.AMP_FAILED,
      value: formattedErrors,
    });
  }
}

function* submit({ value, callback }) {
  const { module, view, ...forms } = value || {};
  try {
    const {
      data
    } = yield call(() => AmpService.submit({ ...forms, module, view }));

    if (data) {
      yield put({ type: types.AMP_SUBMIT_SUCCESS, value: { ...data, ampStatus: data.status, module, view } });
      callback(MessageTypes.SUCCESS, i18next.t('Information submitted successfully'), data);
    } else {
      callback(MessageTypes.WARNING, i18next.t('errors::Something wrong happend during saving data'))
    }
  } catch (e) {
    const formattedErrors = formatErrors(e)
    yield put({
      type: types.AMP_SUBMIT_FAILED,
      value: formattedErrors,
    });
    if (Object.keys(formattedErrors).length > 0) {
      callback(MessageTypes.WARNING, i18next.t('errors::Please fill all required fields'))
    } else {
      callback(MessageTypes.WARNING, i18next.t('errors::Something wrong happend during saving data'))
    }
  }
}

function* publish({ value: { id, module, view }, callback }) {
  try {
    if (typeof id === 'string') {
      const { data } = yield call(() => StakeholderService.publish(id));
      if (data) {
        yield put({ type: types.AMP_PUBLISH_SUCCESS, value: { ...data, module, view } });
        callback(MessageTypes.SUCCESS, i18next.t('Information submitted successfully'));
      } else {
        callback(MessageTypes.WARNING, i18next.t('errors::Something wrong happend during saving data'))
      }
    }
  } catch (e) {
    const formattedErrors = formatErrors(e);
    yield put({
      type: types.AMP_PUBLISH_FAILED,
      value: formattedErrors,
    });
    if (Object.keys(formattedErrors).length > 0) {
      callback(MessageTypes.WARNING, i18next.t('errors::Please fill all required fields'))
    } else {
      callback(MessageTypes.WARNING, i18next.t('errors::Something wrong happend during saving data'))
    }
  }
}

function* getLinking({ value }) {
  try {
    const { data } = yield call(() => StakeholderService.getLinking(value));
    if (data) {
      yield put({ type: types.AMP_LINKING_SUCCESS, value: data });
    }
  } catch (e) {
    const formattedErrors = formatErrors(e);
    yield put({
      type: types.AMP_LINKING_FAILED,
      value: formattedErrors,
    });
  }
}

function* remove({ value, callback }) {
  try {
    const { data } = yield call(() => StakeholderService.remove(value.id, value.data));
    if (data) {
      yield put({ type: types.AMP_REMOVE_SUCCESS, value: data });
      callback(MessageTypes.SUCCESS, i18next.t('Stakeholder deleted'));
    }
  } catch (e) {
    const formattedErrors = formatErrors(e);
    yield put({
      type: types.AMP_REMOVE_FAILED,
      value: formattedErrors,
    });
  }
}

function* approveApplication({ value, callback }) {
  const { module, view, ...forms } = value || {};

  try {
    const {
      data
    } = yield call(() => AmpService.approveApplication(forms, view));

    if (data) {
      switch (view) {
        case 'amp':
          yield put({ type: types.AMP_SUBMIT_SUCCESS, value: { ...data, ampStatus: data.status, module, view } });
          break;
        case 'mine-profile':
          yield put({ type: mineProfileTypes.MINE_PROFILE_SUBMIT_SUCCESS, value: { ...data, ampStatus: data.status, module, view } });
          break;
        case 'ownership-kyc':
          yield put({ type: ownershipKycTypes.OWNERSHIP_KYC_SUBMIT_SUCCESS, value: { ...data, ampStatus: data.status, module, view } });
          break;
        default:
          yield put({ type: types.AMP_SUBMIT_SUCCESS, value: { ...data, ampStatus: data.status, module, view } });
      }
      callback(data);
    } else {
      callback()
    }
  } catch (e) {
    const formattedErrors = formatErrors(e)
    yield put({
      type: types.AMP_SUBMIT_FAILED,
      value: formattedErrors,
    });
    if (Object.keys(formattedErrors).length > 0) {
      callback(MessageTypes.WARNING, i18next.t('errors::Please fill all required fields'))
    } else {
      callback(MessageTypes.WARNING, i18next.t('errors::Something wrong happend during saving data'))
    }
    message.info(e?.response?.data?.message);
  }
}

function* declineApplication({ value, callback }) {
  const { module, view, ...forms } = value || {};
  try {
    const {
      data
    } = yield call(() => AmpService.declineApplication(forms, view));

    if (data) {
      switch (view) {
        case 'amp':
          yield put({ type: types.AMP_SUBMIT_SUCCESS, value: { ...data, ampStatus: data.status, module, view } });
          break;
        case 'mine-profile':
          yield put({ type: mineProfileTypes.MINE_PROFILE_SUBMIT_SUCCESS, value: { ...data, ampStatus: data.status, module, view } });
          break;
        case 'ownership-kyc':
          yield put({ type: ownershipKycTypes.OWNERSHIP_KYC_SUBMIT_SUCCESS, value: { ...data, ampStatus: data.status, module, view } });
          break;
        default:
          yield put({ type: types.AMP_SUBMIT_SUCCESS, value: { ...data, ampStatus: data.status, module, view } });
      }
      callback();
    } else {
      callback()
    }

    message.success(i18next.t('Application has been declined.'));
  } catch (e) {
    console.log(e);
    const formattedErrors = formatErrors(e)
    yield put({
      type: types.AMP_SUBMIT_FAILED,
      value: formattedErrors,
    });
    if (Object.keys(formattedErrors).length > 0) {
      callback(MessageTypes.WARNING, i18next.t('errors::Please fill all required fields'))
    } else {
      callback(MessageTypes.WARNING, i18next.t('errors::Something wrong happend during saving data'))
    }

    message.info(e?.response?.data?.message);
  }
}

function* editApplication({ value, callback }) {
  const { module, view, ...forms } = value || {};

  try {
    const { data } = yield call(() => AmpService.editApplication(forms));

    if (data) {
      switch (view) {
        case 'amp':
          yield put({ type: types.AMP_SUBMIT_SUCCESS, value: { ...data, module, view } });
          break;
        case 'mine-profile':
          yield put({ type: mineProfileTypes.MINE_PROFILE_SUBMIT_SUCCESS, value: { ...data, module, view } });
          break;
        case 'ownership-kyc':
          yield put({ type: ownershipKycTypes.OWNERSHIP_KYC_SUBMIT_SUCCESS, value: { ...data, module, view } });
          break;
        default:
          yield put({ type: types.AMP_SUBMIT_SUCCESS, value: { ...data, module, view } });
      }
      callback(data);
    } else {
      callback();
    }
  } catch (e) {
    message.info(e?.response?.data?.message);
    callback();
  }
}

export default function* initial() {
  yield takeEvery(
    types.AMP_SUBMIT_REQUEST,
    submit,
  );
  yield takeEvery(
    types.AMP_REQUEST,
    get,
  );
  yield takeEvery(
    types.AMP_DATA,
    getData,
  );
  yield takeEvery(
    types.AMP_PUBLISH,
    publish,
  );
  yield takeEvery(
    types.AMP_LINKING,
    getLinking,
  );
  yield takeEvery(
    types.AMP_REMOVE,
    remove,
  );
  yield takeEvery(
    types.AMP_APPROVE_APPLICATION,
    approveApplication,
  );
  yield takeEvery(
    types.AMP_DECLINE_APPLICATION,
    declineApplication,
  );
  yield takeEvery(
    types.AMP_EDIT_APPLICATION,
    editApplication,
  );
}
